<template>
  <div id="app">
    <siteHeader></siteHeader>
    <!-- <div class="blinkOverlay" v-if="!MutableIsIE" ref="blinkOverlay"></div> -->
    <transition name="fade">
      <router-view :key="$route.path">

      </router-view>
    </transition>
    <physics v-if="!MutableIsIE"></physics>

  </div>
</template>

<script>
import EventBus from './util/EventBus'
import * as types from './store/mutation-types'
import SiteHeader from './components/SiteHeader'
import Physics from './components/Physics'
import Home from './views/Home'
import MobileDetect from 'mobile-detect'
import Signature from './util/Signature'

export default {
  name: 'app',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: document.title,
    // all titles will be injected into this template
    titleTemplate: document.title + ' · %s'
  },
  components: {
    SiteHeader,
    Physics,
    Home
  },
  props: {
    isIE: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      md: new MobileDetect(window.navigator.userAgent),
      MutableIsIE: this.isIE
    }
  },
  beforeCreate () {
    this.$store.commit(types.RECEIVE_PAGES, { pages: window.Kirby.pages })
    this.$store.commit(types.RECEIVE_SITE, { site: window.Kirby.site })
  },
  created () {
    window.addEventListener('resize', this.onResize, true)
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('wheel', this.onMouseWheel)
    window.addEventListener('mousewheel', this.onMouseWheel)
    window.addEventListener('DOMMouseScroll', this.onMouseWheel)
    window.addEventListener('orientationchange', this.onOrientationChange)
    window.addEventListener('deviceorientation', this.onDeviceorientation)
    // document.body.addEventListener('click', () => {
    //   if ( typeof( DeviceMotionEvent ) !== "undefined" && typeof( DeviceMotionEvent.requestPermission ) === "function" ) {
    //       // (optional) Do something before API request prompt.
    //       DeviceMotionEvent.requestPermission().then( response => {
    //           // (optional) Do something after API prompt dismissed.
    //           if ( response == "granted" ) {
    //               window.addEventListener( "devicemotion", this.onDeviceorientation)
    //           }
    //       }).catch( console.error )
    //   }

    // })
    this.onResize()
    this.$store.commit(types.UPDATE_APP, { field: 'isMobile', value: this.md.mobile() })

    if (this.md.mobile()) {
      document.body.classList.add('is-mobile')
    }
    if (!this.md.mobile() && process.env.NODE_ENV === 'production') {
			let signature = new Signature('Design & Code')
			// signature.init()
		}
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize, true)
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('wheel', this.onMouseWheel)
    window.removeEventListener('mousewheel', this.onMouseWheel)
    window.removeEventListener('DOMMouseScroll', this.onMouseWheel)
    window.removeEventListener('orientationchange', this.onOrientationChange)
    window.removeEventListener('deviceorientation', this.onDeviceorientation)
  },
  mounted () {
    this.init()
    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', this.viewportHandler.bind(this))
      window.visualViewport.addEventListener('resize', this.viewportHandler.bind(this))
    }
    let ua = window.navigator.userAgent


    let msie = ua.indexOf('MSIE ')
    if (msie > 0) {
      // IE 10 or older => return version number
      this.MutableIsIE = true
      document.body.classList.add('is-ie')
    } else {
      this.MutableIsIE = false
    }

    let trident = ua.indexOf('Trident/')
    if (trident > 0) {
      // IE 11 => return version number
      this.MutableIsIE = true
      document.body.classList.add('is-ie')
    } else {
      this.MutableIsIE = false
    }

    this.$router.beforeResolve((to, from, next) => {

      // this.$refs.blinkOverlay.classList.remove('blink')
      // void this.$refs.blinkOverlay.offsetWidth
      // this.$refs.blinkOverlay.classList.add('blink')

      if (to.name) {
        document.body.classList.add('is-loading')
      }
      next()
    })

    this.$router.afterEach((to, from) => {



      document.body.classList.remove('is-loading')
      // if (to.name === 'home') {
      //   // EventBus.$emit('app.physicsActivate')
      //   this.$store.commit(types.UPDATE_PHYSICS, { field: 'physicsB', value: true })
      // }
      if (from.name === 'home') {
        // EventBus.$emit('app.physicsDelete')
        this.$store.commit(types.UPDATE_PHYSICS, { field: 'physicsB', value: false })
      }
    })

    // if (this.$router.history.current.name === 'home') {
    //   EventBus.$emit('app.physicsActivate')
    // } else {
    //   EventBus.$emit('app.physicsDelete')
    // }
  },
  methods: {
    onResize (event) {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth
      this.$store.commit(types.UPDATE_APP, { field: 'tablet', value: windowWidth <= 700 })
      this.$store.commit(types.UPDATE_APP, { field: 'phone', value: windowWidth <= 480 })

      EventBus.$emit('app.resize', event)
    },
    onScroll (event) {
      EventBus.$emit('app.scroll', event)
    },
    onMouseWheel (event) {
      if (event.type === 'wheel') {
        EventBus.$emit('app.mousewheel', event)
      } else {
        return
      }
      
    },
    onOrientationChange (event) {
      EventBus.$emit('app.orientationchange', event)
    },
    onDeviceorientation (event) {
      EventBus.$emit('app.deviceorientation', event)
    },
    init () {
      if (window.visualViewport) {
        document.documentElement.style.setProperty('--vh', `${window.visualViewport.height}px`)
      }
    },
    viewportHandler (event) {
      if (this.pendingUpdate) return
      this.pendingUpdate = true

      requestAnimationFrame(() => {
        this.pendingUpdate = false
        document.documentElement.style.setProperty('--vh', `${window.visualViewport.height}px`)
      })
    }
  }
}
</script>

<style lang="scss">
  // @import 'node_modules/reset-css/sass/_reset';
  @import './assets/styles/sass';
:root {
  --vh: 100vh;
}
  #app {
  	height: 100%;
  	width: 100%;
		margin: 0;
padding: 0;
  	overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
  }
  // .fade-enter-active {
  //   transition: all 20s ease;
  // }
  // .fade-leave-active {
  //   transition: all 20s ease;
  // }
  // .fade-enter, .fade-leave-to {
  //   opacity: 0;
  // }

  .fade-enter-active {
    transition: opacity 1s 0s ease-in;
  }
  .fade-leave-active {
  	transition: opacity 0.15s ease-out;
  }
  .fade-enter {
  	opacity: 0;
  }

  .fade-leave-to {
  	opacity: 0;
  }

  // @keyframes blinkOverlay {
  //   0% {
  //     opacity: 0;
  //   }
  //   13% {
  //     opacity: 1;
  //   }
  //   100% {
  //     opacity: 0;
  //   }
  // }

  // .blinkOverlay {
  //   display: none;
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   width: 100vw;
  //   height: 100vh;
  //   background: rgb(230,230,230);
  //   pointer-events: none;
  //   z-index: 50;
  //   // mix-blend-mode: exclusion;
  //   opacity: 0;
  //   visibility: hidden;
  //   &.blink {
  //     animation: blinkOverlay 1.2s ease-in;
  //     animation-fill-mode: both;
  //     visibility: visible;
  //   }
  // }

</style>
